import { Component, Input, Renderer2 } from "@angular/core";

import { Development, imageLoad } from "@models/development.model";
import { Project } from "@models/project.model";
import { CommonServiceService } from "@services/common-service.service";
import { DevelopmentService } from "@services/development.service";
import { ImageProcessingService } from "@services/image-processing.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-carousel",
  templateUrl: "./carousel.component.html",
  styleUrls: ["./carousel.component.scss"],
})
export class CarouselComponent {
  @Input()
  notCardImage = false;

  @Input()
  BgColor = "#b5ccd2";

  max_Image_height = 350;

  @Input()
  set development(development: Development) {
    this._development = development;
    this.GetDevelopmentPhotos(this._development.name).then((imageLoad) => {
      if (imageLoad.length === 0) {
        const img = this.renderer.createElement("img");
        this.renderer.listen(img, "load", () => {
          this.imageLoad.push({
            imgPath: environment.defaultDevelopmentPhoto,
            height: img.height,
            width: img.width,
          });
        });
        this.renderer.setAttribute(img, "src", environment.defaultDevelopmentPhoto);
      }
      //this.getImgSize();
    });
    // this.commonServiceService.IdentifyIssueWithFileandFolderNames();
  }

  get development(): Development {
    return this._development;
  }

  @Input()
  set project(project: Project) {
    this._project = project;
    if (this._project.projectImage.length > 0) {
      this.imageLoad = this._project.projectImage;
    } else {
      this.getProjectPhoto(this._project.projectPicture ?? "");
    }
  }
  get project(): Project {
    return this._project;
  }

  imageLoad: imageLoad[] = [];

  _development!: Development;
  _project!: Project;

  constructor(
    private imageProcessingService: ImageProcessingService,
    private renderer: Renderer2,
  ) {
    if (window.innerWidth <= 1280) this.max_Image_height = 250;
  }

  // getImgSize() {
  //   this.imageLoad.forEach((imgSrc) => {
  //     console.log(
  //       !this.notCardImage
  //         ? imgSrc.height > this.max_Image_height && imgSrc.height > imgSrc.width
  //           ? (imgSrc.width / imgSrc.height) * this.max_Image_height + "px"
  //           : "-webkit-fill-available"
  //         : (imgSrc.width / imgSrc.height) * this.max_Image_height + "px",
  //       !this.notCardImage,
  //       imgSrc.height > this.max_Image_height && imgSrc.height > imgSrc.width,
  //       imgSrc.height > this.max_Image_height,
  //       imgSrc.height > imgSrc.width,
  //       imgSrc.height,
  //       imgSrc.width,
  //     );
  //   });
  // }

  async GetDevelopmentPhotos(_development: string): Promise<imageLoad[]> {
    this.imageLoad = [];
    const containerUrl = environment.blobPhotos;

    return new Promise<imageLoad[]>((resolve, reject) => {
      this.imageProcessingService.getDevlopmentBlobs(containerUrl, _development).subscribe(
        (response) => {
          const loadPromises: Promise<void>[] = [];

          response.forEach((x) => {
            const img = this.renderer.createElement("img");
            const loadPromise = new Promise<void>((innerResolve) => {
              this.renderer.listen(img, "load", () => {
                this.imageLoad.push({
                  imgPath: containerUrl.concat(x),
                  height: img.height,
                  width: img.width,
                });
                innerResolve();
              });
            });

            loadPromises.push(loadPromise);
            this.renderer.setAttribute(img, "src", containerUrl.concat(x));
          });

          Promise.all(loadPromises).then(() => {
            resolve(this.imageLoad);
          });
        },
        (error) => {
          console.error(error);
          reject(error);
        },
      );
    });
  }

  async getProjectPhoto(projectPicture: string) {
    try {
      this.imageLoad = [];
      await this.projectPhotos(projectPicture ?? "").then((imageLoad: imageLoad[]) => {
        if (imageLoad.length === 0) {
          const img = this.renderer.createElement("img");
          this.renderer.listen(img, "load", () => {
            this.imageLoad.push({
              imgPath: environment.defaultPhotoPhoto,
              height: img.height,
              width: img.width,
            });
          });
          this.renderer.setAttribute(img, "src", environment.defaultPhotoPhoto);
        }
      });
    } catch (error) {
      console.error("Error updating project image:", error, this._project.projectPicture);
    }
  }

  async projectPhotos(photoName: string): Promise<imageLoad[]> {
    this.imageLoad = [];
    const containerUrl = environment.projectPhotos;
    return new Promise<imageLoad[]>((resolve, reject) => {
      this.imageProcessingService.getProjectBlobPhotos(containerUrl, photoName).subscribe(
        (response) => {
          const loadPromises: Promise<void>[] = [];
          response.forEach((x) => {
            const img = this.renderer.createElement("img");
            const loadPromise = new Promise<void>((innerResolve) => {
              this.renderer.listen(img, "load", () => {
                this.imageLoad.push({
                  imgPath: containerUrl.concat(x),
                  height: img.height,
                  width: img.width,
                });
                innerResolve();
              });
            });

            loadPromises.push(loadPromise);
            this.renderer.setAttribute(img, "src", containerUrl.concat(x));
          });

          Promise.all(loadPromises).then(() => {
            resolve(this.imageLoad);
          });
        },
        (error) => {
          console.error(error);
          reject(error);
        },
      );
    });
  }
}
